/**
 * Agency-name interpolation for tour copy (REQ D4-ONB-011 / D4-WLB).
 *
 * Tour copy is written with a neutral ``{agency}`` token and the branded name
 * is substituted at render time from BrandingContext — so no agency/vendor
 * literal is ever baked into source (the D4-WLB-008 vendor-name grep guard
 * stays green) and every deployment shows its own name.
 */
export function interpolateAgency(text: string, agencyName: string): string {
  return text.replace(/\{agency\}/g, agencyName);
}
